import { useSelector } from 'react-redux';
import type { RootState } from 'reducers/types';
import {
  getCurrency,
  getCurrentCurrency,
  getRecipient,
  getRecurringOffersMetadata,
  getSelectedRecurringOffer,
} from 'selectors';

export function useInstallments() {
  const recipient = useSelector(getRecipient);
  const currencyTo = useSelector(getCurrentCurrency);
  const offer = useSelector(getSelectedRecurringOffer);
  const metadata = useSelector(getRecurringOffersMetadata);
  const currencyFrom = useSelector((state: RootState) => {
    const priceObject = offer.price || {};
    return getCurrency(state, priceObject.currency);
  });

  const installments = offer.installments || [];
  const sortedInstallments = [...installments].sort(
    (a, b) => new Date(a.date).getTime() - new Date(b.date).getTime(),
  );

  const firstInstallment = sortedInstallments[0];
  const lastInstallment =
    sortedInstallments.length > 1
      ? sortedInstallments[sortedInstallments.length - 1]
      : undefined;
  const totalAmount = sortedInstallments.reduce((acc, installment) => {
    return acc + installment.amount;
  }, 0);

  const chargeDay =
    metadata.schedule === 'pay_now'
      ? undefined
      : parseInt(metadata.schedule, 10);

  return {
    chargeDay,
    currencyFrom: currencyFrom,
    currencyTo,
    firstInstallment,
    installments: sortedInstallments,
    lastInstallment,
    numberOfInstallments: sortedInstallments.length,
    price: offer.price,
    recipient,
    recurring: !!offer.recurring,
    totalAmount,
  };
}
